import TYPES from '../types'

const initState = {
  adminLists: null,
  Orders: null,
}

const AdminState = (state = initState, action) => {
  const { type, data } = action
  switch (type) {
    case TYPES.LOGOUT:
      return { ...initState }
    case TYPES.ALT_ADMIN_LISTS:
      return {
        ...state,
        adminLists: data,
      }
    case TYPES.ALT_ADMIN_ORDERS:
      return {
        ...state,
        Orders: data,
      }
    default:
      return state
  }
}

export default AdminState
